import MediaQuery from 'react-responsive';
import React, { Component, PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { globalStyles } from 'styles/globalStyles';
import _ from 'lodash';

function getStyles(width) {
  let totalWidth = width + '%';
  return _.assign({}, globalStyles.cell, { width: totalWidth });
}

export class ReportRow extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  };

  render() {
    const { data, columnsRatio } = this.props;
    const rowClass = data.rank % 2 === 0  ? 'even' : 'odd';
    // We need to calculate width of leftover space after the columns are added/removed
    return (
      <div className={`row ${rowClass}`} style={{display: 'flex'}}>
        {
          Object.keys(data).map((column, i) => (
            <div
              key={`res-row-${i}`}
              className='cell'
              style={getStyles(columnsRatio[column])}>
              {data[column]}
            </div>
          ))
        }
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./components/report/ReportRow.js